module.exports = __webpack_public_path__ + "static/orkut_4-563190039a1167c9f849d5f557fc82ab.png";